<template>
  <div class="login-container">
    <img src="@/assets/images/login/logo.png" class="logo">
    <div class="form-box">
      <van-field
        v-model="form.username"
        type="text"
        left-icon="friends"
        clearable
        size="large"
        placeholder="请输入账号"
      >
        <template #left-icon>
          <svg-icon icon-class="user" />
        </template>
      </van-field>
      <van-field
        v-model="form.password"
        type="password"
        clearable
        size="large"
        placeholder="请输入密码"
      >
        <template #left-icon>
          <svg-icon icon-class="safe" />
        </template>
      </van-field>
      <button class="login-btn" @click="handleLogin">
        登录
      </button>
    </div>
    <div class="agree-box">
      <van-checkbox v-model="form.agree" checked-color="#58A78B" icon-size="16px">
        同意
      </van-checkbox>
      <span @click="popup.agree=true">《用户协议》</span>
    </div>
    <van-popup v-model="popup.agree" position="bottom" class="agree-popup">
      <van-nav-bar title="用户协议" left-arrow @click-left="popup.agree=false" />
      <div class="agree-text">
        <p>欢迎使用农事记（以下简称“本系统”）！在您使用本系统之前，请您务必仔细阅读，充分理解各条款的内容。</p>
        <p>1.本系统有权根据需要制订、修改本《用户须知》内容，并以系统公示的方式进行公告。</p>
        <p>2.本系统适用范围为松潘县行政区域范围内农业种植/养殖户。</p>
        <p>3.本系统由松潘县科学技术和农业畜牧局发行，旨在提升农业种（养）植户的农事记录方式，有效规范投入品使用，进一步将松潘县农业种植过程推上“标准化+互联网”的时代。</p>
        <p>4.本系统为松潘县行政区域范围内农业种植户提供施肥记录、农事操作记录、用药记录、农产品追溯信息、地块信息记录等功能。</p>
        <p>5.本系统为用户提供天气预报、病虫害防治方法、禁用农药清单、限用农药清单等查询功能，提供农药查询和投入品使用数据分析功能。</p>
        <p>6.本系统由松潘县科学技术和农业畜牧局统一授权并分发账号，作为您使用本系统的唯一身份标志。为了保护您的权益，请您在首次登陆时修改登录密码，并妥善保管密码，切勿将密码告知他人，因密码保管不善造成数据泄露损失由您负全责。</p>
        <p>7.该账户的所有权归属松潘县科学技术和农业畜牧局，您仅拥有使用权。</p>
        <p>8.用户有义务维护本系统不受外界人为破坏，更不可私自复制、破解、逆向、修改本产品，不可使用插件、外挂等刻意损害本系统的正常运行，一经查出，用户将承担相应的法律责任。</p>
        <p>9.保证安装本系统的运行环境（包括但不限于软件、硬件环境）不会受到网络攻击等非法入侵。</p>
        <p>10.除开因公共利益需要或用户同意外，本系统对用户提供的所有信息、数据保密，确保不会不正当地用于商业用途。</p>
        <p>11.本系统对直接、间接、偶然、特殊及继起的损害概不负责，这些损害产生的原因包括但不限于不正当使用服务、非法使用服务等。</p>
        <p>12.本系统对包括但不限于网络故障、覆盖范围限制、地震、不可抗力等其他非系统技术范围内的事因造成的服务中断等问题不承担责任。</p>
        <p>13.若因非系统原因导致的用户信息泄露、数据丢失，造成的经济损失本系统不承担任何责任。</p>
        <p>14.用户必须遵守《用户须知》的各项规定，如您有违背《用户须知》的任意一条规定，本系统有权中断或者终止服务。</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import api from '@/api'
import { TOKEN_NAME } from '@/constant/config'
import { checkPermission } from '@/utils/permission'

export default {
  name: 'Login',
  beforeRouteEnter(to, from, next) {
    const token = JSON.parse(localStorage.getItem(TOKEN_NAME))
    if (token) {
      next({ name: 'Home' })
      return
    }
    next()
  },
  data() {
    return {
      popup: {
        agree: false
      },
      form: {
        username: undefined,
        password: undefined,
        agree: true
      }
    }
  },
  methods: {
    handleLogin() {
      if (!this.form.agree) {
        this.$toast('请阅读并同意用户协议')
        return
      }
      api.login(this.form).then(({ data }) => {
        this.$toast('登录成功')
        this.$store.commit('setUserInfo', data)
        this.$store.dispatch('reloadCompanyInfo')
        if (checkPermission(['加工业'])) {
          this.$store.state.menuState = false
          this.$router.push({
            name: 'ProcessList'
          })
        } else {
          this.$router.push({
            name: 'Home'
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login-container {
  position: relative;
  height: 100vh;
  padding: 0 16px;
  background: #F3F7F8;
  overflow: hidden;
}
.logo {
  display: block;
  margin: 60px auto;
  width: 64vw;
}
.form-box {
  .van-cell {
    background: transparent;
    border-bottom: 1px solid #ddd;
  }
  .svg-icon {
    margin-right: 10px;
    font-size: 24px;
    color: #888;
  }
  .login-btn {
    display: block;
    margin: 40px auto 0;
    width: 100%;
    height: 40px;
    background: @primary-color;
    border: none;
    border-radius: 20px;
    color: #fff;
    font-size: 16px;
  }
}
.agree-box {
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #323232;
  span {
    color: @primary-color;
  }
}
.agree-popup {
  .van-nav-bar {
    position: sticky;
    top: 0;
  }
  .agree-text {
    padding: 16px;
    background: #F3F7F8;
  }
  p{
    font-size: 14px;
    color: #555;
    text-indent: 28px;
    padding:0;
    margin:0;
    line-height: 1.8;
  }
}
</style>
